import { Center, MenuItem, MenuItemProps, Text } from "@chakra-ui/react";

interface Props extends MenuItemProps {
  svg: React.ReactNode;
  title: string;
  textColor?: string;
  fw?: string;
}
const IconMenuItem = ({ svg, title, textColor, fw, ...props }: Props) => {
  return (
    <MenuItem
      bg="#F2F4F3"
      gridGap="10px"
      px="0"
      py="8px"
      _hover={{
        transition: "all .5s ease-in",
        zoom: "1.005",
        fontWeight: "500",
      }}
      {...props}
    >
      <Center width="20px" height="18px">
        {svg}
      </Center>

      <Text
        color={textColor ? textColor : "#303131"}
        textTransform="capitalize"
        fontWeight={fw ? fw : "400"}
        _hover={{
          fontWeight: "500",
          transition: "all .5s ease-in",
          zoom: "1.005",
        }}
      >
        {title}
      </Text>
    </MenuItem>
  );
};

export default IconMenuItem;
